<div class="page gs1-background-color-ui-1">
  <a gs1ReturnButton [routerLink]="'/mes-gln'">Revenir à la liste</a>
  <div>
    <h2 class="page-title">Importer mes GLN</h2>
    <p class="gs1-little">L'import vous permet de charger en masse vos GLN sur CodeOnline, de les gérer et de partager leurs informations avec tous vos partenaires commerciaux.</p>
    <p class="gs1-little">
      <span class="gs1-color-slate">A noter que le ré-import de vos GLN se fera par annulation et remplacement de l'existant.</span>
      Le modèle de fichier d'import est à votre disposition en téléchargement ci-dessous.
    </p>
    <button class="download-modele" [thin]="true" gs1Button (click)="getfile()">Télécharger le fichier</button>
  </div>
  <div>
    <!-- <h3>Importer mes GLN, c'est simple !</h3> -->
    <div class="schema">
      <div class="schema-line"></div>
      <div class="schema-step">
        <div class="schema-image">
          <i class="bi bi-cloud-upload"></i>
        </div>
        <div class="schema-legende">
          <span class="gs1-color-blue gs1-little">J’utilise le fichier d’import GS1 France</span>
          <span class="gs1-small">En intégrant mes GLN et les attributs associés.</span>
        </div>
      </div>
      <div class="schema-step">
        <div class="schema-image">
          <i class="bi bi-activity"></i>
        </div>
        <div class="schema-legende">
          <span class="gs1-color-blue gs1-little">Nous analysons votre fichier</span>
          <span class="gs1-small">Avec un rapport d’erreurs généré si besoin.</span>
        </div>
      </div>
      <div class="schema-step">
        <div class="schema-image forest">
          <i class="bi bi-cloud-plus"></i>
        </div>
        <div class="schema-legende">
          <span class="gs1-color-forest-accessible gs1-little">Mes GLN sont importés</span>
          <span class="gs1-small">Et seront disponibles dans ma liste.</span>
        </div>
      </div>
    </div>

  </div>
</div>
<div class="page">
  <h3>Sélectionnez et déposez votre fichier </h3>
  <div>
    <form [formGroup]="uploadForm" *ngIf="uploadForm">
      <gs1-file #file (filesChanged)="setFile($event)" [filesOnBottom]="true" [loading]="sendingFile" formControlName="file" [sizeLimitMb]="30" [acceptedFilesType]="['.xlsx']" >
        <div *ngIf="sendingFile" slot="loading">
          <mat-progress-bar mode="determinate" [value]="uploadProgress" color="primary"></mat-progress-bar>
          <span class="gs1-color-orange gs1-little">Fichier en cours d’analyse…</span>
          <span class="gs1-color-ui-6 gs1-little file-name">{{fileName}}</span>
        </div>
        <span slot=""></span>
      </gs1-file>
      <p class="gs1-legal" *ngIf="uploadForm.valid && !sendingFile">
        Les informations recueillies ici par GS1 France font l’objet d’un traitement destiné à permettre l'usage de Codeonline GLN et pourront, selon les choix effectués sur votre interface, être transmises à des tiers, adhérents à GS1 France.
        <br/>
        Conformément aux dispositions de la loi n°78-17 du 6 janvier 1978 dite « Informatique et Libertés » modifiée, au Règlement UE 2016/679 ou à toute autre disposition normative qui viendrait le compléter ou s’y substituerait, chaque personne, dont les données personnelles sont collectées, dispose d’un droit d’accès, de modification, de rectification et de suppression de ces dernières. Toute personne dont les données personnelles sont collectées dispose également du droit de s’opposer, pour des motifs légitimes, à leur traitement. Ces droits peuvent être exercés à tout moment en adressant un email à <a href="mailto:serviceclient@gs1fr.org">serviceclient@gs1fr.org</a> ou un courrier à Service client GS1 France, 21 boulevard Haussmann 75009 Paris, en nous indiquant la raison sociale de son entreprise, sa référence adhérent, ses nom et prénom, accompagnés de la copie de sa pièce d’identité.
        <br/>
        Pour plus d’information, vous pouvez consulter notre <a target="_blank" href="https://www.gs1.fr/politique-confidentialite">Politique de Confidentialité</a>.
        </p>
      <button gs1Button [thin]="true" *ngIf="uploadForm.valid && !sendingFile" (click)="importFile()">Importer</button>
    </form>
  </div>
  <div>
    <div *ngIf="result; else noResult" id="upload-result" class="upload-result card">
      <h4>Analyse de votre fichier</h4>
      <gs1-alert *ngIf="result.successCount > 0" [type]="'success'">
        <p class="gs1-little"><ng-container *ngIf="result.errorCount === 0">Le fichier <span>{{fileName}}</span> a été analysé avec succès. <br/></ng-container>
          {{result.successCount}} GLN {{result.successCount > 1 ? 'ont été importés': 'a été importé'}} dans votre liste.</p>
      </gs1-alert>
      <gs1-alert [type]="'danger'" *ngIf="result.errorCount > 0">
        <p class="gs1-little"><ng-container *ngIf="result.successCount === 0">Le fichier <span>{{fileName}}</span> comporte des erreurs. <br/></ng-container>
          {{result.errorCount}} GLN {{result.errorCount > 1 ? 'n\'ont pu être importés': 'n\'a pas été importé'}}.</p>
      </gs1-alert>
      <gs1-alert [type]="'danger'" *ngIf="result.successCount === 0 && result.errorCount === 0">
        <p class="gs1-little">
          Le fichier <span>{{fileName}}</span> ne contient aucun GLN à importer.
        </p>
      </gs1-alert>
      <div class="column-divider" *ngIf="!(result.successCount === 0 && result.errorCount === 0)">
        <div class="result-column">
          <h6>{{result.errorCount === 0 ? 'Et maintenant ?' : 'Le fichier comporte des erreurs…'}}</h6>
          <p *ngIf="result.errorCount !== 0" class="gs1-little">Téléchargez le rapport ci-dessous afin de corriger les erreurs.<br/>Réimportez ensuite ce fichier.</p>
          <p *ngIf="result.errorCount === 0" class="gs1-little">Retrouvez dés à présent les GLN importés dans votre liste, <br/>ou importez de nouveaux GLN.</p>
          <button *ngIf="result.errorCount !== 0" gs1Button [appearance]="'outlined'" [color]="'blue'" [thin]="true" (click)="downloadResult()"><i class="bi bi-file-arrow-down"></i>&nbsp;Télécharger le fichier</button>
          <button [routerLink]="'/mes-gln'" *ngIf="result.errorCount === 0" gs1Button [appearance]="'flat'" [color]="'blue'" [thin]="true">Retour à la liste</button>
        </div>
        <div class="result-column">
          <img src="{{result.errorCount === 0 ? '/assets/images/success-img.svg': '/assets/images/error-img.svg'}}" alt="illustration du résultat" />
        </div>
      </div>
    </div>
    <ng-template class="upload-result card" #noResult>
      <gs1-alert [type]="'danger'" *ngIf="wrongFileImported === true">
        <p class="gs1-little">
          Le fichier importé n'est pas valide.
        </p>
      </gs1-alert>
    </ng-template>


  </div>
</div>

